export default __webpack_public_path__ + "static/media/apr2024-4.4e49f9d0.jpg";